import React from 'react';
import './Events.css';

// Dynamically import all images from the 'events' folder
const importAll = (r) => r.keys().map(r);
const images = importAll(require.context('../../images/Events', false, /\.(png|jpe?g|svg)$/));

const shuffleArray = (array) => {
  let currentIndex = array.length, randomIndex;
  
  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array;
};

const Events = () => {
  const shuffledImages = shuffleArray([...images]); // Shuffle the images

  return (
    <div className='events-wrapper'>
    <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Events
        </span>
      </h1>
      <div className='events-grid'>
        {shuffledImages.map((image, index) => (
          <div key={index} className='events-card'>
            <img src={image} alt={`Event ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Events;
